// Available color names for user avatars
const AVAILABLE_COLORS = [
  'blue',
  'green',
  'purple',
  'orange',
  'red',
  'cyan',
  'magenta',
  'gold',
  'azure',
  'lime',
  'volcano',
  'yellow',
];

/**
 * Assigns a consistent color to a user based on their editorId
 * This ensures the same user always gets the same color, even if other users disconnect
 * @param editorId - The editorId of the user
 * @returns The color name for the user
 */
export function getColorForUser(editorId: string): string {
  // Simple hash: sum of character codes
  const hash = editorId
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return AVAILABLE_COLORS[hash % AVAILABLE_COLORS.length];
}
